const T_PREFIX = "chat-item";

export const chatWindowTrns = {
  messagePlaceholder: `${T_PREFIX}.chat-window.message-placeholder`,
  messageListIsEmpty: `${T_PREFIX}.chat-window.message-list-is-empty`,
};
